import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { SignUpComponent } from '../sign-up/sign-up.component';
import { UtilsService } from '../../shared/utils.service';

@Component({
    selector: 'app-pricing-script',
    templateUrl: './pricing-script.component.html',
    styleUrls: ['./pricing-script.component.scss'],
    standalone: false
})
export class PricingScriptComponent implements OnInit {

  constructor(private utils: UtilsService, private router: Router, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.utils.setTitle('Pricing');
  }

  openSignup(type: string, plan: any, subscriptionsCount: number, subscriptionPrice: number, annualFee: number) {
    if (this.utils.isMobile()) {
      this.router.navigate(['/signup'], { state: { data: {
        type,
        plan,
        annualFee,
        subscriptionsCount,
        subscriptionPrice }} });
    } else {
      const dialogRef = this.dialog.open(SignUpComponent, {disableClose: true,
        data: {
          type,
          plan,
          annualFee,
          subscriptionsCount,
          subscriptionPrice,
        }
      });
      dialogRef.afterClosed().subscribe((status) => {
      });
    }
  }

}
